export const PURCHASE_ORDER_PAYMENT_STATUS_OPTIONS = [
  { id: "unpaid", name: "Unpaid" },
  { id: "allocated", name: "Allocated" },
  { id: "partially_paid", name: "Partially Paid" },
  { id: "paid", name: "Paid" },
];
